module.exports = __webpack_public_path__ + "static/media/ic-van.44d69b02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ic-van.svg
// module id = 1957
// module chunks = 0